<div class="case-summary-table-container" *ngIf="caseSummaryList">
  <div class="background">
    <table class="case-summary-table">
      <thead>
      </thead>
      <tbody class="table-body">
          <tr class="table-row" *ngFor="let entry of caseSummaryList; index as i">
            <td class="timeline">
              <div [ngClass]="insertLineBetweenCaseSummaryItems(i)"></div>
              <div  [ngClass]="{'red-circle': entry.unreadMessage || entry.unhandled, 'circle': !entry.unreadMessage}"></div>
            </td>
            <td class="datetime">
              <div class="image-top-margin">
                <app-user-picture
                  *ngIf="!(entry.caseHistoryType === CaseHistoryType.SMS && entry.direction === CommunicationDirection.IN_BOUND)"
                  [imageURL]="getUserImage(entry.userId)" [active]="'true'" [imageClass]="'caseSummaryView'">
                </app-user-picture>
                <div
                  *ngIf="entry.caseHistoryType === CaseHistoryType.SMS && entry.direction === CommunicationDirection.IN_BOUND && smsCreatedByMap[entry.id] != null">
                  <img [src]="smsCreatedByMap[entry.id].icon" class="stakeholder-image">
                </div>
              </div>
              <div class="datetimetext">{{ entry.actionTime | momentFormat: 'DD MMM YYYY - HH:mm': 'local'  }}</div>
              <div class="text-uppercase"
                *ngIf="!(entry.caseHistoryType === CaseHistoryType.SMS && entry.direction === CommunicationDirection.IN_BOUND)">
                {{ getUserInitials(entry.userId) }}</div>
              <div
                *ngIf="entry.caseHistoryType === CaseHistoryType.SMS && entry.direction === CommunicationDirection.IN_BOUND && smsCreatedByMap[entry.id] != null">
                {{smsCreatedByMap[entry.id].type}}
              </div>
            </td>
            <td class="col content">
              <div class="case-summary-item" *ngIf="showNoteEntity(entry.caseHistoryType) === false &&
                  entry.caseHistoryType !== CaseHistoryType.EMAIL &&
                  entry.caseHistoryType !== CaseHistoryType.FAX && entry.caseHistoryType !== CaseHistoryType.EMAIL_RECEIVE && entry.caseHistoryType !== CaseHistoryType.EMAIL_UPDATE &&
                  entry.caseHistoryType !== CaseHistoryType.FAX_RECEIVE && entry.caseHistoryType !== CaseHistoryType.FAX_UPDATE &&
                  entry.caseHistoryType !== CaseHistoryType.SMS && entry.caseHistoryType !== CaseHistoryType.CONSENT && entry.caseHistoryType !== CaseHistoryType.MEDICAL_ASSESSMENT_CREATE &&
                  entry.caseHistoryType !== CaseHistoryType.POLICY_SELECTED && entry.caseHistoryType !== CaseHistoryType.POLICY_REMOVED &&
                  entry.caseSubObjectType !== 'EXTERNAL'">
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.CASE_CREATE">
                  Case <span class="values-blue-color"> </span> reported by <span
                    class="values-blue-color">{{ ChannelTypeEnum[summaryCase.channelType] | lowercase }}</span>
                </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.CASE_NUMBER_CREATE">
                  Created case number <span class="values-blue-color">{{ entry.dataFieldChanges[0].newValue }}</span>
                </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.POLICY_LOOKUP">
                    Insurance lookup performed in <span
                  class="values-blue-color">{{ entry.searchResultParams[0].searchResultParamValue }}</span>
                  </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.SMS"> {{'case-summary-list-sms-sent-to' | translate }}
                  {{entry.to}}</span>
                <span
                  *ngIf="entry.caseHistoryType === CaseHistoryType.SMS_UPDATE">{{ 'case-summary-list-sms-recieved-status-to' |translate }}
                  {{entry.to}} : <span class="values-blue-color">{{entry.newStatus}}</span> </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.STATUS_CHANGE">
                  <span class="values-blue-color">{{ entry.dataFieldChanges[0].field}}</span> set from <span
                    class="values-blue-color">{{ entry.dataFieldChanges[0].oldValue }}</span> to <span
                    class="values-blue-color">{{ entry.dataFieldChanges[0].newValue }}</span>
                </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.DOCUMENT_MOVE"> Attachment:
                    <span class="values-blue-color">{{ entry.dataFieldChanges[0].oldValue}}</span> has been transferred from
                    <span class="values-blue-color">{{ entry.dataFieldChanges && entry.dataFieldChanges.length > 1 ? entry.dataFieldChanges[1].oldValue : ''}}</span>.
                  </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.SCREENING_TOOL_CHANGE">
                    {{ "case-summary-list-updated-screening-tool" | translate}}
                  <span *ngFor="let value of entry.dataFieldChanges">
                      <p>
                        <span class="values-blue-color">
                          {{ value.field | translate }}
                        </span>:
                        <span class="values-blue-color">
                          {{ screeningStateDisplayValueAdapter.getPropertyFromValue(value.newValue) | translate }}
                        </span>
                      </p>
                    </span>
                  </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.CUSTOMER_PRODUCT_ADDED">
                    {{'case-summary-list-customer-product-added' | translate}} <span class="values-blue-color">{{ entry.dataFieldChanges[0].newValue }}</span>
                  </span>
                <span *ngIf="entry.caseHistoryType === CaseHistoryType.CUSTOMER_PRODUCT_UPDATED">
                    {{'case-summary-list-customer-product-updated' | translate}}  <span class="values-blue-color">{{ entry.dataFieldChanges[0].newValue }}</span>
                  </span>
              </div>
              <div class="case-summary-entry" *ngIf="entry.caseHistoryType === CaseHistoryType.EMAIL || entry.caseHistoryType === CaseHistoryType.FAX ||
              entry.caseHistoryType === CaseHistoryType.EMAIL_RECEIVE || entry.caseHistoryType === CaseHistoryType.EMAIL_UPDATE ||
              entry.caseHistoryType === CaseHistoryType.FAX_RECEIVE || entry.caseHistoryType === CaseHistoryType.FAX_UPDATE">
                <app-case-summary-email-fax [case]="case" [entry]="entry" [stakeholders]="stakeholders" [showActionButton]="false"></app-case-summary-email-fax>
              </div>
              <div class="case-summary-entry" *ngIf="entry.caseHistoryType === CaseHistoryType.SMS">
                <app-case-summary-sms [case]="case" [entry]="entry" [showActionButton]="false" [stakeholders]="stakeholders"></app-case-summary-sms>
              </div>
              <div class="casesummery-consent-item" *ngIf="entry.caseHistoryType === CaseHistoryType.CONSENT">
                <app-case-summary-consent [entry]="entry" [stakeholders]="stakeholders"></app-case-summary-consent>
              </div>
              <div class="case-summary-item" *ngIf="entry.caseHistoryType === CaseHistoryType.POLICY_REMOVED || entry.caseHistoryType === CaseHistoryType.POLICY_SELECTED">
                <app-case-summary-policy [entry]="entry"></app-case-summary-policy>
              </div>
              <div class="case-summary-entry" *ngIf="entry.caseHistoryType === CaseHistoryType.CASE_CREATE && entry.caseSubObjectType === 'EXTERNAL'">
                <app-case-summary-external [case]="case" [entry]="entry" [showActionButton]="false" [stakeholders]="stakeholders">
                </app-case-summary-external>
              </div>
              <span *ngIf="entry.caseHistoryType === CaseHistoryType.MEDICAL_ASSESSMENT_CREATE">
                  <div class="card activity-card note">
                    <div class="card-header activity-card-header">
                      <div class="float-start text">
                        <img class="icon-phone" src="/assets/icons/service-order-type/Medical Assessment.svg">

                        <ng-container
                          *ngIf="entry.dataFieldChanges[1].newValue === MedicalNoteTypeEnum.ADMISSION || entry.dataFieldChanges[1].newValue === MedicalNoteTypeEnum.COMMENT">
                          #{{entry.dataFieldChanges[2].newValue}} {{ 'medical-comment-note-was-added' | translate }}
                        </ng-container>

                        <ng-container
                          *ngIf="entry.dataFieldChanges[1].newValue === AssessmentTypeEnum.LIGHT || entry.dataFieldChanges[1].newValue === AssessmentTypeEnum.REGULAR || entry.dataFieldChanges[1].newValue === AssessmentTypeEnum.CLAIMS">
                          #{{entry.dataFieldChanges[2].newValue}}
                          <span
                            *ngIf="entry.dataFieldChanges[1].newValue === AssessmentTypeEnum.LIGHT">{{ 'medical-new-regular-assessment-button-light' | translate }}</span>
                          <span
                            *ngIf="entry.dataFieldChanges[1].newValue === AssessmentTypeEnum.CLAIMS">{{ 'medical-new-regular-assessment-button-claims' | translate }}</span>
                          <span
                            *ngIf="entry.dataFieldChanges[1].newValue === AssessmentTypeEnum.REGULAR">{{ 'medical-new-regular-assessment-button-regular' | translate }}
                            <span *ngIf="entry.dataFieldChanges[3].newValue !== 'null'">
                              <span *ngIf="entry.dataFieldChanges[3].newValue === 'true'">
                                {{ 'case-history-list-with-repatriation-instructions' | translate }} </span>
                              <span *ngIf="entry.dataFieldChanges[3].newValue === 'false'">
                                {{ 'case-history-list-added-with-repatriation-prognosis' | translate }} </span>
                            </span>
                          </span>
                          was published
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </span>
              <span *ngIf="showNoteEntity(entry.caseHistoryType) === true">
                <div class="card activity-card note">
                  <div class="card-header activity-card-header">
                    <div class="float-start text">
                      <div *ngIf="entry.caseObjectType === CaseObjectType.note">
                        <span *ngIf="getNoteType(entry.entityId) === NoteTypeEnum.phone">
                          <img *ngIf="getNoteCalltype(entry.entityId) === CallType.ingoing; else outgoing" class="icon-phone" width='16'
                            height='16' src="/assets/icons/Ingoing.svg">
                          <ng-template #outgoing>
                            <img class="icon-phone" width='16' height='16' src="/assets/icons/Outgoing.svg">
                          </ng-template>
                          {{ getNoteStakeholderType(entry.entityId)}}
                          <span *ngIf="getNoteStakeholderName(entry.entityId) !== ''">({{getNoteStakeholderName(entry.entityId)}})</span>
                        </span>
                        <span *ngIf="getNoteType(entry.entityId) === NoteTypeEnum.case">
                          <img src="/assets/icons/Case note.svg" />
                        </span>

                        <span *ngIf="getNoteType(entry.entityId) === NoteTypeEnum.customer">
                          <img src="/assets/icons/Customer%20Note%20Medium%20Blue.svg" alt="Customer Note icon" />
                        </span>
                        <span *ngIf="getNoteType(entry.entityId) === NoteTypeEnum.supplier">
                          <img class="icon-phone" src="/assets/icons/Customer%20Note%20Medium%20Blue.svg" alt="Supplier Note icon" />
                          <img class="stakeholder-icon" [src]="getStakeholderIcon(entry.entityId)" />
                          <span *ngIf="getNoteStakeholderName(entry.entityId) !== ''">{{ getNoteStakeholderName(entry.entityId) }}</span>
                        </span>
                      </div>
                    </div>
                    <div *ngIf="!isNoteDeleted(entry.entityId)" class="float-end">
                      <div *ngIf="isEdited(entry) && !isCopied(entry.entityId)">Edited &nbsp;</div>
                    </div>
                    <div *ngIf="!isNoteDeleted(entry.entityId)" class="float-end">
                      <div *ngIf="isCopied(entry.entityId) && !isEdited(entry)">Copied &nbsp;</div>
                    </div>
                    <div *ngIf="!isNoteDeleted(entry.entityId)" class="float-end">
                      <div *ngIf="isEdited(entry) && isCopied(entry.entityId)">Edited / Copied &nbsp;</div>
                    </div>
                    <div *ngIf="isNoteDeleted(entry.entityId)" class="float-end">
                      <span class="redText">Deleted &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
                    </div>
                  </div>
                  <div *ngIf="!isNoteDeleted(entry.entityId)" class="card-body activity-card-body border-bottom-shadow">
                    <div class="note-info-text" valign="top">
                      <span *ngIf="getNoteType(entry.entityId) === NoteTypeEnum.phone">
                        <span *ngFor="let descr of getNoteDescriptionSplited(entry.entityId)">
                          <div> {{ descr }} </div>
                        </span>
                      </span>
                      <span *ngIf="getNoteType(entry.entityId) === NoteTypeEnum.customer || getNoteType(entry.entityId) === NoteTypeEnum.supplier">
                        <span *ngFor="let descr of getNoteDescriptionSplited(entry.entityId)">
                          <div>{{ descr }}</div>
                        </span>
                      </span>
                      <span *ngIf="getNoteType(entry.entityId) === NoteTypeEnum.case">
                        <div>{{ getNoteCalltype(entry.entityId)}}</div>
                        <span *ngFor="let descr of getNoteDescriptionSplited(entry.entityId)">
                          <div> {{ descr }} </div>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </span>
            </td>
          </tr>
      </tbody>
    </table>
     <app-pagination [currentPageIndex]="pagingInfo.pageIndex" [totalNumber]="pagingInfo.totalNumber" [pageSize]="pagingInfo.pageSize"
       (pagingChangedEvent)="paginationChanged($event)"></app-pagination>
  </div>
</div>
